export default "__VITE_ASSET__55ca9ea1__"